import { render, staticRenderFns } from "./CardPostSmall.vue?vue&type=template&id=527b99d0&"
import script from "./CardPostSmall.vue?vue&type=script&lang=js&"
export * from "./CardPostSmall.vue?vue&type=script&lang=js&"
import style0 from "./CardPostSmall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports